export default function (schema) {
    if (!schema?.properties) return {};
    return Object.keys(schema.properties).reduce((obj, prop) => {
        if (schema.properties?.[prop].default !== undefined)
            obj[prop] = schema.properties[prop].default;
        return obj;
    }, {});
}
